import { render } from "./PageLogin.vue?vue&type=template&id=2ba29fe5&scoped=true"
import script from "./PageLogin.vue?vue&type=script&lang=js"
export * from "./PageLogin.vue?vue&type=script&lang=js"

import "./PageLogin.vue?vue&type=style&index=0&id=2ba29fe5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba29fe5"]])

export default __exports__